export default {
  accountChangeAplly: "情報の変更申請をする",
  accouuntAppliedBankList: "登録済みの口座一覧",
  accountBankType: "口座種別",
  accountTradePaymentBankInfo: "決済料金振込口座情報"
};
